import { render, staticRenderFns } from "./kitsClone.vue?vue&type=template&id=152e6704"
import script from "./kitsClone.vue?vue&type=script&lang=js"
export * from "./kitsClone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports